module.exports = __webpack_public_path__ + "img/17_86.821ff91e.png";